<!--  -->
<template>
  <div class="m_tech">
    <mb-header theme="dark"></mb-header>

    <div class="header">
      <router-link to="/m_index" class="content_btn">
        <img src="../assets/logo.png" alt class="logo" />
      </router-link>
    </div>
    <div class="body">
      <ul class="nav">
        <li @click="checkTab(1)">
          <img src="../assets/m/4-1.png" alt v-show="curTab != 1" />
          <img src="../assets/m/4-1b.png" alt v-show="curTab == 1" />
        </li>
        <li @click="checkTab(2)">
          <img src="../assets/m/4-2.png" alt v-show="curTab != 2" />
          <img src="../assets/m/4-2b.png" alt v-show="curTab == 2" />
        </li>
        <li @click="checkTab(3)">
          <img src="../assets/m/4-3.png" alt v-show="curTab != 3" />
          <img src="../assets/m/4-3b.png" alt v-show="curTab == 3" />
        </li>
        <li @click="checkTab(4)">
          <img src="../assets/m/4-4.png" alt v-show="curTab != 4" />
          <img src="../assets/m/4-4b.png" alt v-show="curTab == 4" />
        </li>
      </ul>
      <div class="h3">
        <h3 v-show="curTab == 1">齿轮问答</h3>
        <h3 v-show="curTab == 2">图纸下载</h3>
        <h3 v-show="curTab == 3">计算公式</h3>
        <h3 v-show="curTab == 4">齿轮应用</h3>
      </div>
      <div class="part_1" v-show="curTab == 1">
        <div class="search">
          <input
            type="text"
            placeholder="输入关键词快速搜索"
            v-model="searchQuestionValue"
          />
          <span @click="searchQuestions">搜索</span>
        </div>
        <div class="select">
          <select
            name="public-choice"
            class="fast_search_select"
            v-model="selectTechValue"
          >
            <option value disabled>请选择问题类型</option>
            <option
              :value="item.id"
              v-for="item of questionTypeList"
              :key="item.id"
            >
              {{ item.quesstion_category_name }}
            </option>
          </select>
        </div>
        <div class="search_result_right" ref="getheight">
          <ul v-if="!showNoContent">
            <li v-for="(item, index) of answerList" :key="index">
              <h3 class="q">{{ item.questions }}</h3>
              <p v-html="item.answers"></p>
            </li>
          </ul>
          <div v-else>很抱歉，没有查询到内容，请重新输入～</div>
        </div>
      </div>
      <div class="part_2" v-show="curTab == 2">
        <div class="part_2_center">
          <div class="search">
            <input
              type="text"
              placeholder="输入产品型号"
              v-model="searchValue"
            />
          </div>
          <div class="search_btn">
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=' +
                  searchValue +
                  '&lang=zh_CN'
                "
              >
                <span>2D 图纸下载</span>
              </a>
            </div>
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/zout/dxf?product=' +
                  searchValue +
                  '&sun=False'
                "
              >
                <span>CAD 图纸下载</span>
              </a>
            </div>
            <div class="download_btn btn">
              <a
                :href="
                  'https://khk-embedded.partcommunity.com/3d-cad-models/sso?languageIso=en&catalog=khk&PART=' +
                  searchValue
                "
              >
                <span>3D 图纸下载</span>
              </a>
            </div>
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/calc/FFCalc.do?catalogno=' +
                  searchValue +
                  '&lang=zh_CN'
                "
              >
                <span>强度计算</span>
              </a>
            </div>
            <div class="download_btn btn">
              <a
                :href="
                  'https://khkgears.co.jp/khkweb/zout/FFModPic.do?catalogno=' +
                  searchValue +
                  '&lang=zh_CN'
                "
              >
                <span>追加工制图</span>
              </a>
            </div>
            <div class="download_btn btn" @click="showModalpdf">
              <div class="a">
                <span>各国材料及精度等级对照表查阅</span>
              </div>
            </div>
            <div class="download_btn btn">
              <a href="https://khkgears.net/new/">
                <span>Gear Drawing 英文站</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="part_3" v-show="curTab == 3">
        <div class="search">
          <a :href="fileinfo" download target="_blank">
            <span>所有公式打包下载</span>
          </a>
        </div>
        <div class="select">
          <select
            name="public-choice"
            class="fast_search_select"
            v-model="selectTech3Value"
          >
            <option value disabled selected style="display: none">
              请选择您需要预览的公式
            </option>
            <option value="标准齿轮的计算表">标准齿轮的计算表</option>
            <option value="齿数的求法">齿数的求法</option>
            <option value="变位正齿轮的计算">变位正齿轮的计算</option>
            <option value="变位齿轮的计算">变位齿轮的计算</option>
            <option value="齿条与变位正齿轮的啮合计算">
              齿条与变位正齿轮的啮合计算
            </option>
            <option value="变位内齿轮和正齿轮的计算">
              变位内齿轮和正齿轮的计算
            </option>
            <option value="变位内齿轮和正齿轮的计算">
              变位内齿轮和正齿轮的计算
            </option>
            <option value="齿直角方式变位斜齿齿轮的计算">
              齿直角方式变位斜齿齿轮的计算
            </option>
            <option value="齿直角方式斜齿条的计算">
              齿直角方式斜齿条的计算
            </option>
            <option value="轴直角方式斜齿齿条的计算">
              轴直角方式斜齿齿条的计算
            </option>
            <option value="格里森直齿锥齿轮的计算">
              格里森直齿锥齿轮的计算
            </option>
            <option value="标准直齿锥齿轮的计算">标准直齿锥齿轮的计算</option>
            <option value="格里森弧齿锥齿轮的计算">
              格里森弧齿锥齿轮的计算
            </option>
            <option value="齿直角方式变位交错轴斜齿齿轮的计算">
              齿直角方式变位交错轴斜齿齿轮的计算
            </option>
            <option value="轴向模数方式蜗杆蜗轮的计算">
              轴向模数方式蜗杆蜗轮的计算
            </option>
            <option value="齿直角方式蜗杆蜗轮的计算">
              齿直角方式蜗杆蜗轮的计算
            </option>
            <option value="方便的力学换算式">方便的力学换算式</option>
          </select>
          <div class="part_img">
            <p>
              <span>当前预览:</span>
              {{ selectTech3Value }}
            </p>
            <div class="res_img">
              <img
                :src="
                  selectTech3Value
                    ? require('../assets/' + selectTech3Value + '.jpg')
                    : '#'
                "
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="part_4" v-show="curTab == 4">
        <ul>
          <li v-for="(item, index) of gearModuleList" :key="index">
            <video
              :src="item.image_vedio_address"
              v-if="item.image_vedio_type == 3"
              controls="controls"
              @play="playVideo"
              poster="../assets/004txt-应用.png"
            ></video>
            <img
              :src="item.image_vedio_address"
              alt
              v-if="item.image_vedio_type == 1"
            />
            <div class="name">
              <h3>
                {{ item.gear_module_name }}
                <span v-if="item.image_vedio_type != 1">(视频)</span>
              </h3>
              <div v-if="item.image_vedio_type == 1">
                <p>使用产品</p>
                <span>{{ item.gear_module_explain }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-backdrop" v-show="showModal" @click="closeModal">
        <div class="modal" id="modal">
          <div class="modal-close" @click="closeModalCuspor">X</div>

          <div class="modal-header">{{ titleText || "提示" }}</div>
          <div class="modal-body">
            <img :src="PreviewPath" alt />
          </div>
        </div>
      </div>
    </div>
    <mb-fotter :class="{ active: islength }"></mb-fotter>
    <back-top></back-top>
  </div>
</template>

<script>
import request from "../server/request.js";
import mbFotter from "../components/moblie-fotter.vue";
import mbHeader from "../components/moblie-header.vue";
import backTop from "../components/back-top.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    mbFotter,
    mbHeader,
    backTop,
  },

  data() {
    //这里存放数据
    return {
      curTab: this.$route.params.id,
      searchQuestionValue: "",
      questionTypeList: [],
      selectTechValue: "",
      searchValue: "",
      selectTech3Value: "标准齿轮的计算表",
      answerList: [],
      PreviewPath: "",
      fileinfo: "",
      showModal: false,
      titleText: "",
      gearModuleList: [],
      showNoContent: false,
      islength: false,
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {
    searchQuestionValue: function (val, oldval) {
      if (val !== oldval && !val) {
        this.loadData();
        this.showNoContent = false;
      }
    },
    selectTechValue: function (val, oldval) {
      if (val !== oldval) {
        request.getQuestionsById(val, (res) => {
          this.answerList = res.data;
        });
      }
    },
    answerList: function (val) {
      if (val.length < 2) {
        this.islength = true;
      } else {
        this.islength = false;
      }
    },
  },

  //方法集合
  methods: {
    checkTab(i) {
      this.curTab = i;
      if (i !== 1) {
        this.islength = false;
      } else {
        if (this.answerList.length < 2) {
          this.islength = true;
        } else {
          this.islength = false;
        }
      }
    },
    showModalpdf() {
      this.showModal = true;
      this.PreviewPath = require("../assets/new.jpg");
      this.titleText = "各国材料及精度等级对照表";
    },
    closeModalCuspor() {
      this.showModal = false;
    },
    closeModal() {
      const dom = document.getElementById("modal");
      if (dom) {
        if (!dom.contains(event.target)) {
          this.showModal = false;
        }
      }
    },
    searchQuestions() {
      if (!this.searchQuestionValue) {
        alert("请输入关键词");
      } else {
        request.getSearchQuestions(this.searchQuestionValue, (res) => {
          if (res.errcode === 0 && res.data.length === 0) {
            this.showNoContent = true;
            this.answerList = [];
          } else {
            this.answerList = res.data;
          }
        });
      }
    },
    playVideo() {
      const videos = document.getElementsByTagName("video");
      for (let i = videos.length - 1; i >= 0; i--) {
        (function () {
          var p = i;
          videos[p].addEventListener("play", function () {
            for (var j = videos.length - 1; j >= 0; j--) {
              if (j != p) videos[j].pause();
            }
          });
        })();
      }
    },
    loadData() {
      request.getQuestionsType((res) => {
        if (res && res.errcode === 0) {
          this.questionTypeList = res.data;
          request.getQuestionsById(res.data[0].id, (data) => {
            if (data && data.errcode === 0) {
              this.answerList = data.data;
            }
          });
        }
      });
      request.getGearModuleList((res) => {
        if (res && res.errcode === 0) {
          this.gearModuleList = res.data;
        }
      });
      request.getFileDown((res) => {
        if (res && res.errcode === 0) {
          this.fileinfo = res.data.filter(
            (item) => item.file_location === "/khk004c"
          )[0].file_address;
        }
      });
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loadData();
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang='less' scoped>
.m_tech {
  background: #fff9dd;
  min-height: 100vh;
  .header {
    width: 100%;
    .logo {
      margin: 0.3rem 0 0 0.3rem;
      width: 35%;
    }
  }
  .body {
    width: 90%;
    margin: 0.3rem auto 0;
    .nav {
      display: flex;
      li {
        width: 25%;
        margin-right: 2%;
        img {
          width: 100%;
        }
      }
    }
    .part_1 {
      .search {
        display: flex;
        input {
          width: 55%;
          margin-left: 0.2rem;
          height: 0.84rem;
          border-radius: 5px;
          border: 1px solid #0583c9;
          text-align: left;
          padding-left: 0.1rem;
          color: #666;
          outline: none;
        }
        span {
          width: 30%;
          height: 0.84rem;
          margin-left: 0.3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #0583c9;
          border-radius: 5px;
          color: #fff;
          font-weight: 500;
          letter-spacing: 1px;
          cursor: pointer;
        }
      }
      .select {
        width: 90%;
        margin: 0.2rem;
        .fast_search_select {
          width: 100%;
          padding: 0.1rem 0;
          border-radius: 5px;
          border: 1px solid #ccc;
          text-align: center;
          height: 0.84rem;
          background: #fff;
          color: #333;
        }
      }
      .search_result_right {
        padding-top: 0.1rem;
        width: 90%;
        margin-left: 0.2rem;
        // width: 52%;
        ul {
          display: flex;
          flex-direction: column;
          li {
            margin-bottom: 0.3rem;
            h3 {
              font-size: 0.34rem;
              font-weight: 500;
              color: #0583c9;
              margin: 0;
            }
            p {
              margin-left: 0.3rem;
              font-size: 0.24rem;
              color: #333;
              font-weight: 450;
              line-height: 1.5;
            }
          }
        }
      }
    }
    .part_2 {
      .part_2_center {
        display: flex;
        flex-direction: column;
        .search {
          input {
            width: 100%;
            text-align: left;
            padding-left: 0.3rem;
            color: #bdbdbd;
            border: 1px solid #939393;
            height: 0.84rem;
            border-radius: 5px;
            background: #fff;
          }
        }
        .search_btn {
          display: flex;
          flex-direction: column;
          margin-top: 0.36rem;
          .download_btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            border-radius: 5px;
            margin-bottom: 0.36rem;
            background: #0583c9;
            color: #fff;
            font-size: 0.28rem;
            font-weight: 500;
            cursor: pointer;
            &.btn,
            &.a {
              height: 0.84rem;
              a {
                color: #fff;
                span {
                  width: 100%;
                  text-align: center;
                  letter-spacing: 1px;
                }
              }
            }
            a {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                width: 38%;
                display: inline-block;
                margin-right: 10px;
              }
              img {
                width: 20%;
                height: 100%;
              }
            }
          }
        }
      }
    }
    .part_3 {
      .search {
        display: flex;
        a {
          display: block;
          width: 90%;
          margin: 0 auto;
          height: 0.84rem;
          text-align: center;
          line-height: 0.84rem;
          background: #0583c9;
          color: #fff;
          font-size: 0.32rem;
          border-radius: 8px;
        }
      }
      .select {
        width: 90%;
        margin: 0.2rem auto 0;
        .fast_search_select {
          width: 100%;
          padding: 0.1rem 0 0.1rem 0.3rem;
          border-radius: 5px;
          border: 1px solid #ccc;
          text-align: left;
          height: 0.84rem;
          background: #fff;
          color: #333;
        }
      }
      .part_img {
        padding-bottom: 0.3rem;
        p {
          color: #0583c9;
          span {
            font-weight: 600;
            display: inline-block;
            margin-right: 10px;
          }
        }
        .res_img {
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .part_4 {
      margin: 0 auto;
      ul {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        // justify-content: center;
        z-index: 10;
        li {
          width: 49%;
          margin-right: 1%;
          margin-bottom: 0.6rem;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 1),
            rgba(5, 131, 201, 1)
          );
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 100%;
            background-size: 100%;
          }
          video {
            width: 100%;
            // height: 3.6rem;
            background-size: 100%;
            outline: none;
          }
          .name {
            margin-left: 0.2rem;
            padding-bottom: 0.2rem;
            h3 {
              font-size: 0.3rem;
              margin-top: 0.1rem;
              color: #fff;
            }
            p,
            span {
              color: #fff;
              margin-bottom: 0.05rem;
            }
          }
          .vide {
            width: 100%;
            outline: none;
          }
        }
      }
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 9999;
    .modal {
      background: #fff;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      .modal-close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        padding: 0;
        width: 48px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.45);
        text-decoration: none;
        font-size: 18px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: center;
        padding: 0.3rem 0.6rem;
        display: flex;
        font-size: 0.32rem;
      }
      .modal-body {
        height: 100%;
        font-size: 0.28rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .fotter.active {
    position: absolute;
  }
}
</style>    